module.exports = __webpack_public_path__ + "static/media/billboard_01_B.c8d463f8.png";